import { render, staticRenderFns } from "./EmailEdit.vue?vue&type=template&id=1a0625c4&"
import script from "./EmailEdit.vue?vue&type=script&lang=js&"
export * from "./EmailEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmailEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports